(function() {
  'use strict';
  angular.module('eva2-angular').filter('trusted', function($sce) {
    return $sce.trustAsHtml;
  });
})();

